import _ from "lodash";
import { ICampaignDetailsState, ICampaignEanexSubmitData } from "../../app/store/campaign/details/types";
import CampaignEanexSubmitData from "../../entities/campaigns/eanex/CampaignEanexSubmitData";


export default class CampaignSubmitDataEanexFactory {

  static create (campaignDetailsState: ICampaignDetailsState, hash: string): ICampaignEanexSubmitData {
    return new CampaignEanexSubmitData(
      campaignDetailsState.offerId,
      campaignDetailsState.optionId,
      campaignDetailsState.channelName,
      {
        TARIFF_PACKAGE: {
          valid: _.get(campaignDetailsState, "tp.id")
        }
      },
      hash
    );
  }

}
